export enum Priority {
    Block = 'block',
    Low = 'low',
    Medium = 'medium',
    High = 'high'
}
